import { Component, OnInit, AfterViewInit } from '@angular/core';
import { RestService } from 'src/app/services/rest.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  standalone: false,
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss'],
})
export class CategoryComponent implements OnInit, AfterViewInit {
  all_category: any = [];
  private observer!: IntersectionObserver;

  constructor(
    private rest: RestService,
    private router: Router,
    private _sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.all_cat();
  }

  ngAfterViewInit() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            (entry.target as HTMLElement).classList.add('revealed');
            this.observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.06, rootMargin: '0px 0px -40px 0px' }
    );
    this.attachObserver();
  }

  private attachObserver() {
    document.querySelectorAll('.cat-item').forEach(el => this.observer.observe(el));
  }

  all_cat() {
    this.rest.allCat().subscribe((res: any) => {
      this.all_category = res;
      this.all_category.forEach((element: any) => {
        if (element.image != null) {
          element.image.image_url = `${environment.apiUrl}/images/?id=${element.image.image_url}`;
        } else {
          element.image = { image_url: 'assets/images/rk.jpeg' };
        }
      });
      setTimeout(() => this.attachObserver(), 80);
    });
  }

  cat_details(value: any) {
    localStorage.setItem('catName', value.name);
    this.router.navigate(['/Products', value.id]);
  }
}
